import { HttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LocationsUpdateComponent } from '../../@theme/components/locations-update/locations-update.component';
import { WebpageComponent } from '../../@theme/components/Webpage/webpage.component';
import { WebpagemanagerComponent } from '../../@theme/components/webpagemanager/webpagemanager.component';
import { AngularMaterialModule } from '../../angular-material.module';
import { createTranslateLoader, SharedModule } from '../../shared.module';
import { ActionBarComponent } from './dashboard/actionbar/actionbar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DetailRowComponent } from './dashboard/detail-row/detail-row.component';
import { MapInfoRoutesComponent } from './dashboard/map-info-routes/map-info-routes.component';
import { RouteEndpointsDialogComponent } from './dashboard/route-endpoints-dialog/route-endpoints-dialog.component';
import { StopTableComponent } from './dashboard/stop-table/stop-table.component';
import { TabRouteListComponent } from './dashboard/tabroutelist/tabroutelist.component';
import { ResizableDirective } from './dashboard/resizable.directive';
import { MatTableModule } from '@angular/material';
import { MarkerClusterDirective } from '../../@theme/directives/marker-cluster.directive';
import { LocationsExceptionComponent } from '../../@theme/components/locations-exception/locations-exception.component';
import { CrmModule } from './crm/crm.module';

@NgModule({
  declarations: [
    DashboardComponent,
    MapInfoRoutesComponent,
    RouteEndpointsDialogComponent,
    DetailRowComponent,
    ActionBarComponent,
    TabRouteListComponent,
    LocationsUpdateComponent,
    LocationsExceptionComponent,
    WebpageComponent,
    ResizableDirective,
    MarkerClusterDirective,
    StopTableComponent,
    WebpagemanagerComponent
  ],
  entryComponents: [RouteEndpointsDialogComponent],
  exports: [AngularMaterialModule, SharedModule],
  imports: [
    MatTableModule,
    CrmModule,
    SharedModule,
    AngularMaterialModule,
    FormsModule,
    RouterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthModule {}
